module.exports = __webpack_public_path__ + "static/media/chat.cde4048d.svg";